import { render } from "./FeedItem.vue?vue&type=template&id=382e3b86&scoped=true"
import script from "./FeedItem.vue?vue&type=script&lang=js"
export * from "./FeedItem.vue?vue&type=script&lang=js"

import "./FeedItem.vue?vue&type=style&index=0&id=382e3b86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-382e3b86"]])

export default __exports__